import React from "react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";

const StyledButton = styled.span`
  color: #5e6f64;
  min-width: 5rem;
  position:relative;
  z-index:10;
  display: block;
  font-weight: bold;
  font-size: 1.3rem;
  border: solid #5e6f64 1px;
  padding: 0.1em 0.6em;
  box-shadow: 1px 1px 14px rgba(0, 0, 0, 0.2);
  font-family: "Titillium Web", sans-serif;
  font-weight: bolder;
  flex: 1 1 100%;
  margin-top: 1rem;
  overflow:hidden;

  &:before{
    content:"";
    position: absolute;
    top:0;
    left: 0;
    bottom:0;
    right:0;
    background: rgba(94,111,111);
    z-index:-3;
    transition: 300ms ease-in-out;
    border-radius:6px;
    transform-origin: left;
    transform:scaleX(0);
  }


  &:hover:before,
  &:active:before {
    transform:scaleX(1.1);
  }
  &:hover,
  &:active {
    color: white;
    border: solid white 1px;
    transition: background-color 0.3s;
  }
  @media (min-width: 480px) {
    & {
      padding: 0.6rem;
      margin: 1rem 0;
      display: block;
      text-align: center;
    }
    @media (min-width: 1200px) {
      & {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        padding: 0.8rem;
      }
    }
  }
`;

const Button = ({ to, children }) => {
  return (
    <Link to={to ? to : "#!"}>
      <StyledButton>{children}</StyledButton>
    </Link>
  );
};

export default Button;
